export default {
    methods: {
        modificationsString(modifications) {
            return modifications
                .map((modification) => `<span class="text-gray-400">${modification.title}:</span> ${modification.options.join(', ')}`)
                .join(' ')
        },
    }
}
